import { createIsomorphicLogger } from "./logger/isomorphicLogger"

const logger = createIsomorphicLogger('utils.retryUtils')

export async function withRetry<T>(fn: () => Promise<T>, retries = 3, delay = 200): Promise<T> {
	for (let i = 0; i < retries; i++) {
		try {
			return await fn()
		} catch (e) {
			if (i === retries - 1) throw e
			logger.error(`Retry ${i + 1} failed: ${(e as Error).message}. Retrying in ${delay}ms...`)
			await new Promise(res => setTimeout(res, delay))
		}
	}
	throw new Error('Unreachable')
}